export { AccordionItemLegacy } from './AccordionItemLegacy';
export type { AccordionIconType } from './AccordionItemLegacy';
